<template>
  <b-modal
    :id="`modalUserProfile${this.user._id}`"
    size="xl"
    :title="`${this.$t('menu.settings.accessProfile.myProfile')}`"
    @hidden="resetData"
  >
    <div v-if="!loading">
      <div class="row col-12 m-auto p-0">
        <div class="row col-7 m-auto">
          <div class="col-7 px-4">
            <div class="profile-pic ml-4 mb-3">
              <font-awesome-icon :icon="['fas', 'user']" />
            </div>
            <h5>{{ this.username }}</h5>
          </div>

          <div class="col-5">
            <div>
              <label for="status"
                >{{ $t('menu.settings.accessProfile.status') }}:</label
              >
              <p
                class="col-6 bg-primary text-center text-light font-weight-bold"
              >
                {{ this.user_data.active === true ? 'Ativo' : 'Inativo' }}
              </p>
            </div>

            <div>
              <label for="cadastrado"
                >{{ $t('menu.settings.accessProfile.registeredIn') }}:</label
              >
              <p>{{ dateFormat(user_data.createdAt) }}</p>
            </div>

            <div>
              <label for="ultimoAcesso"
                >{{ $t('menu.settings.accessProfile.lastLogin') }}:</label
              >
              <p>{{ dateFormat(user_data.lastLogin) }}</p>
            </div>
          </div>

          <h5 class="ml-4 mb-3">
            {{ $t('menu.settings.accessProfile.personalInformation') }}
          </h5>

          <div class="col-12 d-flex">
            <div class="col-7">
              <div class="form-group">
                <label for="name"
                  >{{ $t('menu.settings.accessProfile.nameUser') }}:</label
                >
                <div v-if="this.editname === false">
                  <div class="d-flex">
                    <p class="col-8 p-0 hideOverflow">
                      {{ this.user_data.name }}
                    </p>

                    <button
                      class="btn btn-outline-primary ml-2"
                      @click="editUserName"
                    >
                      <font-awesome-icon :icon="['fas', 'pen']" />
                    </button>
                  </div>
                  <div v-if="this.errorName === true" class="text-danger">
                    {{ $t('menu.settings.accessProfile.informName') }}
                  </div>
                </div>

                <div v-if="this.editname === true">
                  <div class="d-flex">
                    <input
                      type="text"
                      v-model="user_data.name"
                      id="eName"
                      class="form-control col-8"
                    />
                    <button
                      class="btn btn-outline-primary ml-2"
                      @click="editUserName"
                    >
                      <font-awesome-icon :icon="['fas', 'plus']" />
                    </button>
                  </div>
                  <div v-if="this.errorName === true" class="text-danger">
                    {{ $t('menu.settings.accessProfile.informName') }}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="email">
                  {{ $t('menu.settings.accessProfile.email') }}:</label
                >
                <div>
                  <div class="d-flex">
                    <p class="col-8 p-0">
                      {{ this.user_data.email }}
                    </p>
                  </div>

                  <div v-if="this.errorEmail === true" class="text-danger">
                    {{ $t('menu.settings.accessProfile.informEmail') }}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="eTelephone"
                  >{{ $t('menu.settings.accessProfile.telephone') }}:</label
                >
                <div v-if="this.editTelefone === false">
                  <div class="d-flex">
                    <p class="col-8 p-0 hideOverflow">
                      +{{ this.user_data.celPhone }}
                    </p>

                    <button
                      class="btn btn-outline-primary ml-2"
                      @click="editUserTelefone"
                    >
                      <font-awesome-icon :icon="['fas', 'pen']" />
                    </button>
                  </div>

                  <div v-if="this.errorTelephone === true" class="text-danger">
                    {{ $t('menu.settings.accessProfile.informTelephone') }}
                  </div>
                </div>

                <div v-if="this.editTelefone === true">
                  <div class="d-flex">
                    <input
                      type="text"
                      v-model="user_data.celPhone"
                      id="eTelephone"
                      class="form-control col-8"
                    />
                    <button
                      class="btn btn-outline-primary ml-2"
                      @click="editUserTelefone"
                    >
                      <font-awesome-icon :icon="['fas', 'plus']" />
                    </button>
                  </div>
                  <div v-if="this.errorTelephone === true" class="text-danger">
                    {{ $t('menu.settings.accessProfile.informTelephone') }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-5">
              <div class="form-group">
                <label for="perfil"
                  >{{ $t('menu.settings.accessProfile.profile') }}:</label
                >
                <p>{{ this.user_data.type }}</p>
              </div>

              <div class="form-group">
                <label for="eCargo"
                  >{{ $t('menu.settings.accessProfile.post') }}:</label
                >
                <div v-if="this.editCargo === false">
                  <div class="d-flex">
                    <p class="col-10 p-0 hideOverflow">
                      {{ this.user_data.occupation }}
                    </p>

                    <button
                      class="btn btn-outline-primary ml-2"
                      @click="editUserCargo"
                    >
                      <font-awesome-icon :icon="['fas', 'pen']" />
                    </button>
                  </div>

                  <div v-if="this.errorCargo === true" class="text-danger">
                    {{ $t('menu.settings.accessProfile.informPost') }}
                  </div>
                </div>

                <div v-if="this.editCargo === true">
                  <div class="d-flex">
                    <input
                      type="text"
                      v-model="user_data.occupation"
                      id="eCargo"
                      class="form-control col-10"
                    />
                    <button
                      class="btn btn-outline-primary ml-2"
                      @click="editUserCargo"
                    >
                      <font-awesome-icon :icon="['fas', 'plus']" />
                    </button>
                  </div>
                  <div v-if="this.errorCargo === true" class="text-danger">
                    {{ $t('menu.settings.accessProfile.informPost') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-5 border-left p-4">
          <label>{{ $t('menu.settings.accessProfile.accessPassword') }}</label>

          <div class="senhaAcesso px-3 pt-2 mb-2 col-8">
            {{ $t('menu.settings.accessProfile.securityPassword') }}
          </div>

          <div class="form-group col-8 p-0">
            <label for="senhaAtual"
              >{{ $t('menu.settings.accessProfile.currentPassword') }}:</label
            >
            <input
              type="password"
              class="form-control"
              id="senhaAtual"
              v-model="currentPassword"
            />
            <div class="text-danger">
              <p>{{ this.error.errorCurrentPass }}</p>
            </div>
          </div>

          <div class="form-group col-8 p-0">
            <label for="novaSenha"
              >{{ $t('menu.settings.accessProfile.newPassword') }}:</label
            >
            <input
              @input="checkPassword"
              type="password"
              class="form-control"
              id="novaSenha"
              v-model="newPassword"
            />
            <ul>
              <span class="invalid-feedback">
                <li>
                  {{ $t('menu.settings.users.invalidFeedbackSamePass') }}
                </li>
              </span>
              <span v-if="!contains_eight_characters">
                <li class="invalid-password-user">
                  {{ $t('menu.settings.users.messages.eightCharacters') }}
                </li></span
              >
              <span v-if="!contains_number"
                ><li class="invalid-password-user">
                  {{ $t('menu.settings.users.messages.containNumbers') }}
                </li>
              </span>
              <span v-if="!contains_uppercase"
                ><li class="invalid-password-user">
                  {{ $t('menu.settings.users.messages.containCapitalLetters') }}
                </li>
              </span>
              <span v-if="!contains_special_character">
                <li class="invalid-password-user">
                  {{
                    $t('menu.settings.users.messages.containSpecialCharacters')
                  }}
                </li>
              </span>
            </ul>
            <div class="text-danger">
              <p>{{ this.error.errorNewPass }}</p>
            </div>
          </div>

          <div class="form-group col-8 p-0">
            <label for="confirmarSenha"
              >{{
                $t('menu.settings.accessProfile.confirmNewPassword')
              }}:</label
            >
            <input
              type="password"
              class="form-control"
              id="confirmarSenha"
              v-model="confirmPassword"
            />
            <div class="text-danger">
              <p>{{ this.error.errorConfirmPass }}</p>
            </div>
          </div>
          <div>
            <button
              @click="alterPassword"
              class="btn btn-md btn-outline-primary"
            >
              {{ $t('menu.settings.accessProfile.updatePassword') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="btn-user-div mt-2">
        <button class="btn btn-secondary" @click="closeModal()">
          {{ $t('menu.settings.users.buttonCancel') }}
        </button>
        <button class="btn btn-primary ml-3" @click="editUserProfile()">
          {{ $t('menu.settings.users.buttonSave') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import swal from 'sweetalert';

export default {
  props: ['user'],

  name: 'modal-user-profile',

  data() {
    return {
      editname: false,
      editEmail: false,
      editTelefone: false,
      editCargo: false,
      username: null,
      errorName: null,
      errorEmail: null,
      errorTelephone: null,
      errorCargo: null,
      loading: true,
      currentPassword: null,
      confirmPassword: null,
      newPassword: null,
      error: {},
      contains_eight_characters: true,
      contains_number: true,
      contains_uppercase: true,
      contains_special_character: true,
      valid_password: true,
    };
  },

  computed: {
    ...mapState('users', ['user_data']),
  },

  methods: {
    ...mapActions('users', ['getUser', 'editUser', 'updatePassword']),

    async resetData() {
      await this.getUser({
        token: this.user.token,
        userId: this.user._id,
      });
      this.username = this.user_data.name;
      this.editname = false;
      this.editEmail = false;
      this.editTelefone = false;
      this.editCargo = false;
      this.errorName = null;
      this.errorEmail = null;
      this.errorTelephone = null;
      this.errorCargo = null;
      this.currentPassword = null;
      this.confirmPassword = null;
      this.newPassword = null;
      this.error = {};
    },

    async alterPassword() {
      if (!this.valid_password) {
        swal(
          this.$t(
            'changePassword.tooltips.strongPasswordValidation.description',
          ),
          '',
          'error',
        );
      } else {
        const obj = {
          token: JSON.parse(localStorage.getItem('_indecx')).token,
          data: {
            newPassword: this.newPassword,
            confirmPassword: this.confirmPassword,
            currentPassword: this.currentPassword,
          },
          userId: JSON.parse(localStorage.getItem('_indecx'))._id,
        };

        try {
          await this.updatePassword(obj);
          swal(
            this.$t('menu.settings.accessProfile.messages.updatePassword'),
            '',
            'success',
          );
          this.resetData();
        } catch (err) {
          this.error = err.response.data;
        }
      }
    },

    async closeModal() {
      this.resetData();
      this.$bvModal.hide(`modalUserProfile${this.user._id}`);
    },

    editUserName() {
      this.editname = !this.editname;
    },

    editUserEmail() {
      this.editEmail = !this.editEmail;
    },

    editUserTelefone() {
      this.editTelefone = !this.editTelefone;
    },

    editUserCargo() {
      this.editCargo = !this.editCargo;
    },

    dateFormat(param) {
      const date = format(new Date(param), 'dd/MM/yyyy HH:mm', { locale: pt });
      return date;
    },

    editUserProfile() {
      if (this.user_data.name === '') {
        this.errorName = true;
        document.getElementById('eName').style.border = '1px solid red';
      }

      if (this.user_data.email === '') {
        this.errorEmail = true;
        document.getElementById('eEmail').style.border = '1px solid red';
      }

      if (this.user_data.celPhone === '') {
        this.errorTelephone = true;
        document.getElementById('eTelephone').style.border = '1px solid red';
      }

      if (this.user_data.occupation === '') {
        this.errorCargo = true;
        document.getElementById('eCargo').style.border = '1px solid red';
      }

      if (
        this.user_data.name !== '' &&
        this.user_data.email !== '' &&
        this.user_data.celPhone !== '' &&
        this.user_data.occupation !== ''
      ) {
        const obj = {
          data: {
            loggedUser: this.user._id,
            name: this.user_data.name,
            email: this.user_data.email,
            celPhone: this.user_data.celPhone,
            occupation: this.user_data.occupation,
          },

          token: this.user.token,
          userId: this.user._id,
        };

        this.editUser(obj).then(() => {
          swal(
            this.$t('menu.settings.accessProfile.messages.editUser.title'),
            this.$t(
              'menu.settings.accessProfile.messages.editUser.description',
            ),
            'success',
          ).then(async () => {
            this.resetData();
          });
        });
      }
    },
    checkPassword() {
      this.password_length = this.newPassword.length;

      const formatPwd = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

      if (this.password_length > 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }

      this.contains_number = /\d/.test(this.newPassword);
      this.contains_uppercase = /[A-Z]/.test(this.newPassword);
      this.contains_special_character = formatPwd.test(this.newPassword);

      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
  },

  async mounted() {
    await this.getUser({
      token: this.user.token,
      userId: this.user._id,
    });

    this.username = this.user_data.name;

    this.loading = false;
  },
};
</script>

<style scoped>
.profile-pic {
  background: #f4f4f4;
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  font-size: 50px;
  color: #b7b7b7;
}

.btn-user-div {
  text-align: right;
}

label {
  font-weight: bold;
  margin: 0;
}

.senhaAcesso {
  background-color: #f4f4f4;
  line-height: 1.2rem;
  font-size: 12px;
  padding-bottom: 1px;
}

.hideOverflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invalid-password-user {
  font-size: 80%;
  color: #d50000;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-user-profile/index.vue